import script from "./SetupOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupOrganization.vue?vue&type=script&setup=true&lang=js"

import "./SetupOrganization.vue?vue&type=style&index=0&id=8265ffcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8265ffcc"]])

export default __exports__